// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__OWdgo","wrapper":"menu_wrapper__+9O8o","content":"menu_content__+bjvc"};